export const READ_CONFIG = '@@config/READ_CONFIG'

export interface ConfigState {
	SCHEME: string;
	SEARCH_HOST: string;
	API_SERVER: string;
	MESSAGING_API_SERVER: string;
	MESSAGING_WS_SERVER: string;
	LYNXCLOUD_CLIENT: string;
	LYNXADMIN_CLIENT: string;
	LYNXREMOTE_CLIENT: string;
	LYNXACTIVITIES_CLIENT: string;
	LYNXVNC_CLIENT: string;
	CLUSTER_URL: string;
	ENVIRONMENT: string;
}

export interface Config {
	SCHEME: string;
	SEARCH_HOST: string;
	API_SERVER: string;
	MESSAGING_API_SERVER: string;
	MESSAGING_WS_SERVER: string;
	LYNXCLOUD_CLIENT: string;
	LYNXADMIN_CLIENT: string;
	LYNXREMOTE_CLIENT: string;
	LYNXACTIVITIES_CLIENT: string;
	LYNXVNC_CLIENT: string;
	CLUSTER_URL: string;
	ENVIRONMENT: string;
}

interface ReadConfigAction {
	type: typeof READ_CONFIG;
	payload: Config;
}

export type ConfigActionTypes = ReadConfigAction
